<script lang="ts">
  import type { ComponentProps } from 'svelte';
  import type ItemImage from './item-image.svelte';
  import ItemBuildTreeNode from './item-build-tree-node.svelte';

  export let id: number;
  export let imageSize: ComponentProps<ItemImage>['size'] = 3;
  export let noTooltip = false;
</script>

<div class="item-build-tree">
  <ItemBuildTreeNode {id} {imageSize} {noTooltip} />
</div>

<style lang="postcss">
  .item-build-tree {
    ---line-width: 1px;
    ---node-gap: 0.4rem;
    ---line-color: var(--mauve-6);
    ---line: var(---line-width) solid var(---line-color);
    ---radius: var(--radius-1);
  }
</style>
